'use client'

import React from 'react'
import CategoriesSlider from '../CategoriesSlider'
import MegaInfoCard from '../Megaschool/MegaInfoCard'
import { assortmentMock } from '@/assets/data/assortmentMock'
import AssortmentInfo from './AssortmentInfo'
import { useTranslation } from 'react-i18next'
import productImage from '@/assets/img/product-mock.png'



interface Props {
    type: string,
    id?: string
}



const Assortment: React.FC<Props> = ({ type, id="megaschool" }) => {
    const {t} = useTranslation()

    const assortmentInfo = {
        tag: t('forCustomers'),
        title: t('our_range'),
        text: t('you_can_order_any_component_from_a_wide_range'),
        btn: {
            content: t('make_an_order'),
            link: '#'
        }
    }

    const assortmentMock = [
        {
            tag: t('componentsUpper'),
            title: t('amino_acids'),
            image: productImage
        },
        {
            tag: t('componentsUpper'),
            title: t('vitaminsUpper'),
            image: productImage
        },
        {
            tag: t('componentsUpper'),
            title: t('dyes'),
            image: productImage
        }
    ]

    return (
        <div className='megaschool' id={id}>
            <AssortmentInfo item={assortmentInfo} />
            <div className="megaschool__cards-wrapper">
                <CategoriesSlider page='trading' list={assortmentMock} />
            </div>
        </div>
    )
}

export default Assortment